"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = exports.MenuPanel = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactDomInteractions = require("@floating-ui/react-dom-interactions");

var _theming = require("@storybook/theming");

var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));

var _styles = require("../shared/styles");

var _MenuButton = require("./MenuButton");

var _MenuItem = require("./MenuItem");

var _excluded = ["items", "children", "label", "primary"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MenuPanel = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1ah3emc0"
} : {
  target: "e1ah3emc0",
  label: "MenuPanel"
})("width:200px;margin:0;z-index:999;background:", _styles.color.lightest, ";border-radius:4px;", _styles.shadows.tooltip, ";");
exports.MenuPanel = MenuPanel;
var Menu = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var items = _ref.items,
      children = _ref.children,
      label = _ref.label,
      primary = _ref.primary,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      activeIndex = _useState4[0],
      setActiveIndex = _useState4[1];

  var listItemsRef = (0, _react.useRef)([]);
  var nodeId = (0, _reactDomInteractions.useFloatingNodeId)();

  var _useFloating = (0, _reactDomInteractions.useFloating)({
    open: open,
    onOpenChange: setOpen,
    middleware: [(0, _reactDomInteractions.offset)({
      mainAxis: 4,
      alignmentAxis: 0
    }), (0, _reactDomInteractions.flip)(), (0, _reactDomInteractions.shift)()],
    placement: 'bottom-start',
    nodeId: nodeId,
    whileElementsMounted: _reactDomInteractions.autoUpdate
  }),
      x = _useFloating.x,
      y = _useFloating.y,
      reference = _useFloating.reference,
      floating = _useFloating.floating,
      strategy = _useFloating.strategy,
      context = _useFloating.context;

  var _useInteractions = (0, _reactDomInteractions.useInteractions)([(0, _reactDomInteractions.useClick)(context, {
    toggle: true,
    ignoreMouse: false
  }), (0, _reactDomInteractions.useRole)(context, {
    role: 'menu'
  }), (0, _reactDomInteractions.useDismiss)(context), (0, _reactDomInteractions.useListNavigation)(context, {
    listRef: listItemsRef,
    activeIndex: activeIndex,
    onNavigate: setActiveIndex,
    loop: true,
    focusItemOnOpen: false,
    openOnArrowKeyDown: true
  })]),
      getReferenceProps = _useInteractions.getReferenceProps,
      getFloatingProps = _useInteractions.getFloatingProps,
      getItemProps = _useInteractions.getItemProps;

  var mergedReferenceRef = (0, _react.useMemo)(function () {
    return (0, _reactMergeRefs["default"])([ref, reference]);
  }, [reference, ref]); // Attach ids to each item within the groups
  // Even though the items are nested within groups,
  // we need to attach ids based on a the top counter

  var options = (0, _react.useMemo)(function () {
    var index = 0;
    return items.reduce(function (acc, item) {
      if ('items' in item) {
        var itemsWithId = item.items.map(function (childItem) {
          var itemWithId = _objectSpread(_objectSpread({}, childItem), {}, {
            id: index
          });

          index += 1;
          return itemWithId;
        });
        return acc.concat(_objectSpread(_objectSpread({}, item), {}, {
          items: itemsWithId
        }));
      }

      index += 1;
      return acc.concat(_objectSpread(_objectSpread({}, item), {}, {
        id: index
      }));
    }, []);
  }, [items]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MenuButton.MenuButton, (0, _extends2["default"])({
    open: open,
    primary: primary
  }, getReferenceProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: mergedReferenceRef,
    onClick: function onClick(event) {
      event.stopPropagation();
      event.currentTarget.focus();
    }
  }))), label), /*#__PURE__*/_react["default"].createElement(_reactDomInteractions.FloatingPortal, null, open && /*#__PURE__*/_react["default"].createElement(_reactDomInteractions.FloatingFocusManager, {
    context: context,
    modal: true // Touch-based screen readers will be able to navigate back to the
    // reference and click it to dismiss the menu without clicking an item.
    // This acts as a touch-based `Esc` key. A visually-hidden dismiss button
    // is an alternative.
    ,
    order: ['reference', 'content']
  }, /*#__PURE__*/_react["default"].createElement(MenuPanel, getFloatingProps({
    ref: floating,
    style: {
      position: strategy,
      top: y !== null && y !== void 0 ? y : 0,
      left: x !== null && x !== void 0 ? x : 0
    }
  }), options.map(function (option) {
    return 'items' in option ? /*#__PURE__*/_react["default"].createElement(_MenuItem.MenuGroup, {
      key: option.label,
      label: option.label
    }, option.items.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement(_MenuItem.MenuItem, (0, _extends2["default"])({
        key: item.label,
        href: item.link.url,
        LinkWrapper: item.link.linkWrapper,
        icon: item.icon
      }, getItemProps({
        role: 'menuitem',
        ref: function ref(node) {
          listItemsRef.current[item.id] = node;
        },
        onClick: function onClick() {
          setOpen(false);
        }
      })), item.label);
    })) : /*#__PURE__*/_react["default"].createElement(_MenuItem.MenuItem, (0, _extends2["default"])({
      key: option.label,
      href: option.link.url,
      LinkWrapper: option.link.linkWrapper,
      icon: option.icon
    }, getItemProps({
      role: 'menuitem',
      ref: function ref(node) {
        listItemsRef.current[option.id] = node;
      },
      onClick: function onClick() {
        setOpen(false);
      }
    })), option.label);
  })))));
});
exports.Menu = Menu;
Menu.displayName = 'Menu';